// extracted by mini-css-extract-plugin
export var tooltip = "tokenomics-pie-chart-module--tooltip--1uHWl";
export var tooltipColor = "tokenomics-pie-chart-module--tooltipColor--13xYu";
export var tooltipValue = "tokenomics-pie-chart-module--tooltipValue--1nKaF";